export const getTrendingSearchesPathForLocation = (slug) =>
    `/trending/searches/${slug}/`;
